const development: boolean = process.env.NODE_ENV === 'development'

export default function isDev(): boolean {
  //console.log(process.env.REACT_APP_VERSION, process.env.NODE_ENV, process.env)
  return development
}
